<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            角色管理
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row style="float: left;">
                    <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;" :header-cell-style="tabHeader">


                        <el-table-column prop="name" label="名称" width="100"></el-table-column>

                        <el-table-column prop="sort" label="排序" width="100"></el-table-column>
                        <el-table-column prop="listMenu" label="权限">
                            <template slot-scope="scope">
                                <span v-for="item in scope.row.listRoleMenuRelDTO" v-bind:key="item.menuCode">
                                    <span v-if="item.menuDTO != null ">{{item.menuDTO.name}}</span>,
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column fixed="right" label="操作" width="180">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.name != '超级管理员'" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                                <el-button v-if="scope.row.name != '超级管理员'" type="text" @click="handleEditMenuButton(scope.$index, scope.row)">编辑菜单按钮</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
        <EditMenuButton ref="myEditMenuButton" v-show="showModalEditMenuButton" v-on:closeEdit="closeEditMenuButton" v-on:getList="getList"></EditMenuButton>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import EditMenuButton from "./EditMenuButton";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,

                showModalAdd:false,
                showModalEdit:false,
                showModalEditMenuButton:false,

                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,

            }
        },
        components:{
            Add,Edit,EditMenuButton
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{

            // 修改table header的背景色
            tabHeader() {
                return 'color:#333;font-weight:bold;'
            },

            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            handleEditMenuButton(index, row) {
                this.$refs.myEditMenuButton.init(row);
                this.showModalEditMenuButton = !this.showModalEditMenuButton;
            },
            closeEditMenuButton:function(){
                this.showModalEditMenuButton = !this.showModalEditMenuButton;
            },


            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },













            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Role/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.pageInfoRoleDTO.list;
                        this.totalItems = response.data.data.pageInfoRoleDTO.total;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>

<style scoped>

</style>
